import { UploaderComponent } from './uploader.component';
import { Routes } from '@angular/router';
import { UploaderGuard } from '@app/core/guards/uploader.guard';
import { DropboxUploaderGuard } from '@app/core/guards/dropbox-uploader.guard';
import { DropboxCreatedGuard } from '@app/core/guards/dropbox-created-guard.guard';
import { PrepareGuard } from '@app/core/guards/prepare-guard.guard';
import { SendGuard } from '@app/core/guards/send-guard.guard';
import { DropboxPrepareGuard } from '@app/core/guards/dropbox-prepare-guard.guard';
import { DropboxSendGuard } from '@app/core/guards/dropbox-send-guard.guard';

export const UPLOADER_ROUTES: Routes = [
  {
    path: '',
    component: UploaderComponent,
    canActivate: [UploaderGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('@app/client/uploader/desktop/modules/landing/landing.module').then(m => m.LandingModule),
      },
      {
        path: 'prepare',
        pathMatch: 'full',
        canActivate: [PrepareGuard],
        loadChildren: () => import('@app/client/uploader/desktop/modules/prepare/prepare.module').then(m => m.PrepareModule),
      },
      {
        path: 'send',
        pathMatch: 'full',
        canActivate: [SendGuard],
        loadChildren: () => import('@app/client/uploader/desktop/modules/send/send.module').then(m => m.SendModule),
      },
      {
        path: 'request-created',
        pathMatch: 'full',
        canActivate: [DropboxCreatedGuard],
        loadChildren: () => import('@app/client/uploader/desktop/modules/send/send.module').then(m => m.SendModule),
      },
    ]
  },
  {
    path: 'request',
    component: UploaderComponent,
    canActivate: [DropboxUploaderGuard],
    children: [
      {
        path: ':dropboxId',
        pathMatch: 'full',
        loadChildren: () => import('@app/client/uploader/desktop/modules/landing/landing.module').then(m => m.LandingModule),
      },
      {
        path: ':dropboxId/prepare',
        pathMatch: 'full',
        canActivate: [DropboxPrepareGuard],
        loadChildren: () => import('@app/client/uploader/desktop/modules/prepare/prepare.module').then(m => m.PrepareModule),
      },
      {
        path: ':dropboxId/send',
        pathMatch: 'full',
        canActivate: [DropboxSendGuard],
        loadChildren: () => import('@app/client/uploader/desktop/modules/send/send.module').then(m => m.SendModule),
      },
    ]
  }
];
